import React, { FC } from 'react';
import { Typography } from '@mui/material';

import { makeStyles } from 'tss-react/mui';

type Props = {
  className?: string;
  type?: string;
};

const useStyles = makeStyles<Props>()((_) => ({
  title: {
    fontWeight: 'bold',
    fontSize: '48px',
    lineHeight: '116.7%',
    alignItems: 'center',
    textAlign: 'center',
    color: '#434C55',
    marginBottom: '34px'
  },
}));

export const AuthTitle: FC<Props> = ({
  type = '',
  className = '',
  children,
}) => {
  const { classes } = useStyles({ type });

  return (
    <Typography variant="h1" className={`${classes.title} ${className}`}>
      {children}
    </Typography>
  );
};

